import { useEditor } from '@craftjs/core';
import {
	ListItem as MuiListItem,
	ListItemIcon,
	ListItemText
} from '@mui/material';
import React, { useCallback } from 'react';
import { SingleElementData } from '../types';
import StyledItem from './StyledItem';

const ListItem: React.FC<SingleElementData> = ({
	editorComponent,
	icon,
	label,
	...props
}) => {
	const { connectors, actions } = useEditor();
	const ref = useCallback(
		(ele: HTMLLIElement | null) =>
			ele &&
			connectors.create(ele, editorComponent, {
				onCreate: (nodeTree) => {
					actions.selectNode(nodeTree.rootNodeId);
					// injecting the CraftJs generated id to the component
					actions.history.ignore().setProp(nodeTree.rootNodeId, (nodeProps) => {
						nodeProps.id = nodeTree.rootNodeId;
					});
				}
			}),
		[actions, editorComponent, connectors]
	);

	return (
		<MuiListItem
			{...props}
			ref={ref}
			component="li"
			sx={{ px: 3, py: 0.5, cursor: 'move' }}
		>
			<StyledItem>
				<ListItemIcon sx={{ minWidth: 24, marginRight: 1, img: { width: 24 } }}>
					{icon}
				</ListItemIcon>
				<ListItemText primary={label} />
			</StyledItem>
		</MuiListItem>
	);
};

export default ListItem;
